// uiInitialState.js
// UI 状態管理用 初期 state
export const uiInitialState = {
  sidebarCollapsed: false,
};
